webpackJsonp([2],{

/***/ "fwK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__("BQ2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("jYI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Page__ = __webpack_require__("QYBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Content__ = __webpack_require__("FcPK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ActionBar__ = __webpack_require__("4e4/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ActionButton__ = __webpack_require__("UxTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DatesDisplay__ = __webpack_require__("f0Ws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_LocationStr__ = __webpack_require__("VVKR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_fields_InputField__ = __webpack_require__("5XUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fields_TextareaField__ = __webpack_require__("W6NO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_Validators__ = __webpack_require__("RFUj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ScrollToErrors__ = __webpack_require__("pj9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__state_actions_eventActions__ = __webpack_require__("Hstv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__state_actions_contactActions__ = __webpack_require__("50FS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_icon_success_svg__ = __webpack_require__("Wjl/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_icon_success_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_icon_success_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_BrowserUtils__ = __webpack_require__("WCoG");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h3",
  null,
  "Message Sent"
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
  label: "Name",
  type: "text",
  name: "name",
  component: __WEBPACK_IMPORTED_MODULE_10__components_fields_InputField__["a" /* default */],
  required: true,
  validate: __WEBPACK_IMPORTED_MODULE_12__utils_Validators__["b" /* required */]
});

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
  label: "Message",
  name: "message",
  component: __WEBPACK_IMPORTED_MODULE_11__components_fields_TextareaField__["a" /* default */],
  required: true,
  validate: __WEBPACK_IMPORTED_MODULE_12__utils_Validators__["b" /* required */]
});

var ContactForm = function ContactForm(_ref) {
  var contact = _ref.contact,
      event = _ref.event,
      handleSubmit = _ref.handleSubmit,
      sendMessage = _ref.sendMessage;

  var save = function save(values) {
    sendMessage(event.data._id, values);
  };
  var ticketString = "Get Tickets";
  var theme = event && event.data && event.data.theme ? event.data.theme : null;
  if (theme && theme.ticketButtonText) {
    ticketString = theme.ticketButtonText;
  }
  if (contact.sent) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        {
          style: {
            background: "url(" + __WEBPACK_IMPORTED_MODULE_16__assets_images_icon_success_svg___default.a + ") no-repeat center",
            backgroundSize: 120,
            padding: "170px 0 40px 0",
            textAlign: "center"
          }
        },
        _ref2
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_6__components_ActionBar__["a" /* default */],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
          { href: "/" + event.data.slug + "/tickets" },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_7__components_ActionButton__["a" /* default */],
            null,
            ticketString
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
          {
            style: {
              padding: "18px 0px",
              display: "inline-block"
            },
            href: "/" + event.data.slug
          },
          "Back to Event"
        )
      )
    );
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "form",
    { onSubmit: handleSubmit(save) },
    contact && contact.error ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "p",
      { "class": "text-error" },
      contact.error.message
    ) : "",
    _ref3,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
      label: "Email",
      type: "email",
      name: "email",
      component: __WEBPACK_IMPORTED_MODULE_10__components_fields_InputField__["a" /* default */],
      required: true,
      validate: [__WEBPACK_IMPORTED_MODULE_12__utils_Validators__["b" /* required */], __WEBPACK_IMPORTED_MODULE_12__utils_Validators__["a" /* email */]]
    }),
    _ref4,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_6__components_ActionBar__["a" /* default */],
      null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_7__components_ActionButton__["a" /* default */],
        { disabled: contact.loading, loading: contact.loading },
        "Submit"
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
        {
          style: {
            padding: "18px 0px",
            display: "inline-block"
          },
          href: "/" + event.data.slug
        },
        "Back to Event"
      )
    )
  );
};

ContactForm = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["f" /* reduxForm */])({
  form: "contact",
  onSubmitFail: function onSubmitFail(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_13__utils_ScrollToErrors__["a" /* scrollToErrors */])();
  }
})(ContactForm);

ContactForm = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    contact: state.contact
  };
}, {
  sendMessage: __WEBPACK_IMPORTED_MODULE_15__state_actions_contactActions__["f" /* sendMessage */]
})(ContactForm);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("p", null);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ContactForm, null);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h2",
  null,
  "FAQ"
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h4",
  null,
  "Location"
);

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h4",
  null,
  "Dates"
);

var _ref11 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "p",
  null,
  "Tickets are not required to attend this event. Your invoice/receipt is attached as a PDF file to your order confirmation sent from orders@humanitix.com to the buyer\u2019s email address, once you have completed your purchase. If you are having trouble finding them, please check your spam folder or contact the organiser to resend."
);

var _ref12 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "p",
  null,
  "Your tickets are included in your order confirmation email sent from orders@humanitix.com. If you are having trouble finding them please check your spam folder or contact the organiser to resend."
);

var Contact = function (_Component) {
  _inherits(Contact, _Component);

  function Contact() {
    _classCallCheck(this, Contact);

    return _possibleConstructorReturn(this, _Component.call(this));
  }

  Contact.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        event = _props.event,
        getEvent = _props.getEvent,
        eventSlug = _props.eventSlug,
        orderId = _props.orderId,
        reset = _props.reset;

    reset();
    if (!event.data && !event.loading) {
      getEvent(eventSlug);
    }
    Object(__WEBPACK_IMPORTED_MODULE_17__utils_BrowserUtils__["a" /* pageChange */])("Contact", event);
  };

  Contact.prototype.render = function render(_ref5) {
    var event = _ref5.event;

    if (!event || !event.data) {
      return;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_4__components_Page__["a" /* default */],
      { background: false, border: false },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_5__components_Content__["a" /* default */],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "div",
          {
            "class": "columns event",
            style: { height: "100%", padding: "50px 24px" }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "div",
            { "class": "column col-8 col-sm-12 pad-lg event-info" },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "h1",
              null,
              "Contact " + event.data.name
            ),
            function () {
              return _ref6;
            },
            event.data.organiser ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "h3",
              null,
              "Event organiser: ",
              event.data.organiser.name
            ) : null,
            event.data.organiser && event.data.organiser.description ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "p",
              null,
              event.data.organiser.description
            ) : null,
            _ref7
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "div",
            { "class": "column col-4 col-sm-12" },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "div",
              { style: { padding: 24 }, "class": "box" },
              _ref8,
              _ref9,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9__components_LocationStr__["a" /* default */], { location: event.data.location }),
              _ref10,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__components_DatesDisplay__["a" /* default */], {
                dates: event.data.dates,
                eventSlug: event.data.slug
              }),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                "h4",
                { style: { marginTop: 18 } },
                "Where are my tickets"
              ),
              event.data.settings.sendTickets === false ? _ref11 : _ref12
            )
          )
        )
      )
    );
  };

  return Contact;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
  return { event: state.event };
}, {
  getEvent: __WEBPACK_IMPORTED_MODULE_14__state_actions_eventActions__["u" /* getEvent */],
  reset: __WEBPACK_IMPORTED_MODULE_15__state_actions_contactActions__["e" /* reset */]
})(Contact));

/***/ })

});


// WEBPACK FOOTER //
// 2.chunk.4a62d.js